import React from "react";

import { Tabs, Tab } from "react-bootstrap";

import { withRouter } from "react-router-dom";

import PaymentsTable from "./components/tables/PaymentsTable";
import InStoreTable from "./components/tables/InStoreTable";
import Stores from "./components/tables/StoresTable";
import PayoutsTable from "./components/tables/PayoutsTable";

import CompanyProcessors from "./CompanyProcessors";

import Setting from "./components/modal/UpdateCompanyModal";
import AddOns from "./components/modal/AddOnModal";

import FeesSection from "./components/package/CompanyFees";

import Backend from "../utils/Backend";
import Splink from "../utils/Splink";

const TABS = [
  {
    eventKey: "payments",
    title: "Payments",
    component: PaymentsTable,
  },
  {
    eventKey: "fees",
    title: "Fees",
    component: FeesSection,
  },
  // {
  //   eventKey: "terminals",
  //   title: "Terminals",
  //   component: InStoreTable,
  //   className: "terminals",
  // },
  {
    eventKey: "processors",
    title: "Processors",
    component: CompanyProcessors,
  },
  {
    eventKey: "stores",
    title: "Stores",
    component: Stores,
  },
  {
    eventKey: "settings",
    title: "Settings",
    component: Setting,
  },
  {
    eventKey: "addons",
    title: "Add-ons",
    component: AddOns,
  },
];

const PAYOUT_PROCESSOR_SLUGS = [
  "stripe",
  "stripe_test",
  "stripe_standard",
  "stripe_standard_test",
  "adyen",
  "adyen_test",
];

const GRATUITY_TAB = {
  eventKey: "gratuity",
  title: "Gratuity/Tips",
  component: PaymentsTable,
};

const PAYOUTS_TAB = {
  eventKey: "payouts",
  title: "Payouts",
  component: PayoutsTable,
};

class CompanyDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeKey: TABS[0].eventKey,
      company: null,
      processorSlugs: [],
      loading: true,
    };
  }

  componentDidMount() {
    const { company_id } = this.props.match.params;
    Backend.getCompanyById(company_id)
      .then((company) => this.setState({ company, loading: false }))
      .catch(() => this.setState({ loading: false }));
    Backend.getCompanyProcessors(company_id).then(companyProcessors => {
      const processorSlugs = companyProcessors.map(companyProcessor => {
        return companyProcessor.processor.slug
      })
      this.setState({
        processorSlugs,
        loading: false,
      })
    }).catch(error => {
      this.setState({ loading: false })
    })
  }

  handleSelect = (key) => {
    this.setState({ activeKey: key });
  };

  render() {
    const { activeKey, company, loading, processorSlugs } = this.state;

    const showGratuity = company?.add_ons?.gratuity
    const showPayout = PAYOUT_PROCESSOR_SLUGS.some((slug) =>
      processorSlugs.includes(slug)
    );

    let tabs = showPayout
      ? [...TABS.slice(0, 3), PAYOUTS_TAB, ...TABS.slice(3)]
      : TABS;

    tabs = showGratuity ? [...tabs.slice(0, 1), GRATUITY_TAB, ...TABS.slice(1)] : tabs;

    const activeTab = tabs.find((tab) => tab.eventKey === activeKey);
    const ActiveComponent = activeTab?.component;
    const tabClassName = activeTab?.className || "";

    if (loading) return <div>Loading...</div>;
    if (!company) return <div>Company not found</div>;

    let componentProps = {
      company,
      match: this.props.match,
      variation: "company-detail",
      class: "v2",
    };

    if (activeTab.eventKey === "payments") {
      componentProps = {
        ...componentProps,
        showHeader: false,
        key: "payments"
      };
    }

    if (activeTab.eventKey === "gratuity") {
      componentProps = {
        ...componentProps,
        showHeader: false,
        gratuity: true,
        key: "gratuity"
      };
    }

    if (activeTab.eventKey === "payouts") {
      componentProps = {
        ...componentProps,
        processorSlugs
      }
    }

    return (
      <div className="company-detail">
        <div className="t-box">
          <div className="s-top">
            <h3>{company.name}</h3>
            <button
              className="btn btn-outline-primary"
              onClick={() => {
                let url = Splink.getSplinkUrl(company);
                window.open(url);
              }}
            >
              View Payment Link
            </button>
          </div>
          <Tabs
            className="v3"
            activeKey={activeKey}
            onSelect={this.handleSelect}
          >
            {tabs.map((tab) => (
              <Tab
                eventKey={tab.eventKey}
                title={tab.title}
                key={tab.eventKey}
              />
            ))}
          </Tabs>
        </div>
        <div className={tabClassName}>
          {ActiveComponent && <ActiveComponent {...componentProps} />}
        </div>
      </div>
    );
  }
}

export default withRouter(CompanyDetail);
